export default {
  control: (styles, { height }) => ({
    ...styles,
    height: height,
    ':hover': {
      ...styles[':hover'],
      border: '1px 1px 1px 0 solid #B2B2B2',
      borderColor: '#B2B2B2',
    },
    ':focus': {
      ...styles[':focus'],
      border: '1px 1px 1px 0 solid #B2B2B2',
      borderColor: '#B2B2B2',
    },
    ':active': {
      ...styles[':active'],
      border: '1px 1px 1px 0 solid #B2B2B2',
      borderColor: '#B2B2B2',
    },
    borderColor: 'rgba(178,178,178,0.5)',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    boxShadow: 'inset 0 2px 3px 0 rgba(0,0,0,0.2)',
    boxSizing: 'borderBox'
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? '#B2B2B2' : '#FFFFFF',
      paddingTop: '2px',
      paddingBottom: '2px',
      fontWeight: 'bold',
      fontSize: '14px',
      width: '100%',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#FFFFFF',
        color: '#333333',
      },
      ':hover': {
        ...styles[':hover'],
        backgroundColor: '#E87721',
        color: '#ffffff',
      }
    }
  },
  input: (styles) => ({
    ...styles,
    ':hover': {
      ...styles[':hover'],
      border: '1px 1px 1px 0 solid #B2B2B2',
    },
    ':focus': {
      ...styles[':focus'],
      border: '1px 1px 1px 0 solid #B2B2B2',
    },
    ':active': {
      ...styles[':active'],
      border: '1px 1px 1px 0 solid #B2B2B2',
    },
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    width: 1,
    marginBottom: 0,
    marginTop: 0,
    backgroundColor: '#000000',
    opacity: '10%',
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    color: '#333333',
    ':hover': {
      color: '#333333',
    },
  }),
  valueContainer: (styles) => ({
    ...styles,
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#333333',
  }),
}
